module.exports = __webpack_public_path__ + "./docs/img/burger_menu.5e7238a59a6acae0774ee808e2720e58.svg";